<script lang="ts" setup>
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'

defineProps({
	data: {
		title: {
			type: String,
		},
		description: {
			type: String,
		},
		link: {
			type: String,
		},
	},
})

function sendGaEvent() {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		button_name: 'User Dropdown Menu Member Center',
		page_name: '',
	})
}
</script>

<template>
	<a
		class="mt-24px flex w-full justify-center whitespace-nowrap rounded-sm bg-o-50 px-16px py-12px tracking-wider text-n-950 hover:bg-o-100 hover:text-n-950 active:bg-o-50/75 lg:mb-8px lg:mt-0"
		:href="data.link"
		@click="sendGaEvent"
	>
		<div class="flex w-full items-center justify-between gap-8px">
			<div class="flex w-full gap-16px">
				<div class="w-[60px] shrink-0">
					<i class="bs-new-icon icon-member-center h-[60px] w-[60px]"></i>
				</div>

				<div class="flex w-[176px] flex-col justify-center gap-4px">
					<div class="typography-s1-emp w-full whitespace-normal break-all">
						{{ data.title }}
					</div>
					<div class="typography-c2-reg w-full whitespace-normal break-all">
						{{ data.description }}
					</div>
				</div>
			</div>
			<i class="bs-new-icon icon-new-chevron h-16px w-16px basis-16px"></i>
		</div>
	</a>
</template>
